import { EGamificationRewardActionType, SOCKET_EVENTS } from '@constants';
import { IAchievedRewardNotification } from '@sdk/contracts';
import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfettiCanvas } from '@/components/ConfettiCanvas';
import { GamificationNotificationContent } from '@/components/GamificationNotificationContent';
import { useSocket } from '@/hooks';
import { useMyFirstSteps } from '@/hooks';
import { useMyGamificationRewards } from '@/store/gamification';

export const GamificationNotifications = () => {
  const [messageInstance, contextHolder] = message.useMessage();
  const { invalidate } = useMyGamificationRewards();
  const { invalidate: invalidateFirstSteps } = useMyFirstSteps();
  const { on, off } = useSocket();
  const { t } = useTranslation('DefaultTranslations');

  const [confettiTrigger, setConfettiTrigger] = useState(false);
  const showNotification = useCallback(
    (notification: IAchievedRewardNotification['notification']) => {
      const { action, points } = notification;
      const isAdding = action === EGamificationRewardActionType.ADD;
      messageInstance.open({
        content: <GamificationNotificationContent isAdding={isAdding} points={points} />,
        className: 'gamification-notification',
        duration: 2
      });
    },
    [messageInstance]
  );

  useEffect(() => {
    const onSendUserReward = ({ notification }: IAchievedRewardNotification) => {
      invalidate();
      invalidateFirstSteps();
      showNotification(notification);
    };
    const onAllFirstStepsCompleted = () => {
      message.success(t('ALL_FIRST_STEPS_COMPLETED'));
      setConfettiTrigger(prev => !prev);
    };

    on(SOCKET_EVENTS.SEND_USER_REWARD, onSendUserReward);
    on(SOCKET_EVENTS.ALL_FIRST_STEPS_COMPLETED, onAllFirstStepsCompleted);

    return () => {
      off(SOCKET_EVENTS.SEND_USER_REWARD, onSendUserReward);
      off(SOCKET_EVENTS.ALL_FIRST_STEPS_COMPLETED, onAllFirstStepsCompleted);
    };
  }, [on, off, invalidate, invalidateFirstSteps, showNotification, t]);

  return (
    <>
      {contextHolder}
      <ConfettiCanvas trigger={confettiTrigger} />
    </>
  );
};
